import { GET_TRANSACTIONS_PAYMENT_TRAY, UPDATE_TRANSACTIONS_PAYMENT_TRAY } from './../constants';
import { handleActions } from "redux-actions"

export const userCodes  = handleActions(
  { 
    [ GET_TRANSACTIONS_PAYMENT_TRAY ]: (state, action) => [ ...action.payload ],
    [ UPDATE_TRANSACTIONS_PAYMENT_TRAY ]: (state, action) => {
      const result  = action.payload.result
            const { sequence } = result
            const userCodes  = state
            const initialValue = []
            const newUserCode = userCodes.reduce((acc, user) => {
                if (user.sequence === sequence) {
                  // console.log('encuantra')
                    return [...acc, result]
                } else {
                    return [...acc, user]
                }
            }, initialValue)
            return newUserCode
    },
  }, []
)